import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { HeaderAdmin } from '../../../components/molecues';
import { Button, Select, Calendar, Toast, LoadingView } from '../../../../common/components/atoms';
import { ModalDialog } from '../../../../common/components/molecues';

import { COURSE_N, ERROR_MESSAGE } from '../../../common/constants.js';
import { PopupMessage, POPUP_TYPE } from '../../../common/PopupMessage';
import { validationEmail, validationDate } from '../../../../common/helper/validation.js';
import { getRandomText } from '../../../../common/helper/commonHelper.js';

import { USERTYPE, USERTYPE_TEXT, PERMISSION_TEXT, SHADOWING_SEND_TWICE } from '../../../common/constants.js';

const EditRow = (props) => {
    const title = props.title.split("<br />")
    return (
        <Row Display={props.Display}>
            <Title>
                {title[0]}<br />{title[1]}
            </Title>
            <Data Enable={props.Enable} Required={props.Required}>
                {props.data}
            </Data>
        </Row>
    )
}
class UserEdit extends Component {
    constructor(props) {
        super(props);

        this.refCalendar = React.createRef();
        this.refTable = React.createRef();
        this.refToast = React.createRef();
        this.state = {
            createUser: this.props.userEdit ? false : true,
            id: this.props.userEdit ? this.props.userEdit.id : "",
            address: this.props.userEdit ? this.props.userEdit.address : "",
            type: this.props.userEdit ? this.props.userEdit.type : USERTYPE_TEXT["0"],
            permission: this.props.userEdit ? this.props.userEdit.permission : "0",
            course: this.props.userEdit ? this.getCourseTextToIndex(this.props.userEdit.course) : "0",
            sendCount: this.props.userEdit ? this.props.userEdit.sendCount : 0,
            subscribeDate: this.props.userEdit ? this.props.userEdit.subscribeDate : this.getDisplayDate(),
            paymentDate: this.props.userEdit ? this.props.userEdit.paymentDate : "",
            unsubscribeDate: this.props.userEdit ? this.props.userEdit.unsubscribeDate : "",
            recessStartDate: this.props.userEdit ? this.props.userEdit.recessStartDate : "",
            recessEndDate: this.props.userEdit ? this.props.userEdit.recessEndDate : "",
            activateDate: this.props.userEdit ? this.props.userEdit.activateDate : "",
            lastLoginDate: this.props.userEdit ? this.props.userEdit.lastLoginDate : "",
            shadowingSendTwice: this.props.userEdit ? (this.props.userEdit.shadowingSendTwice ? this.props.userEdit.shadowingSendTwice : "") : SHADOWING_SEND_TWICE.NOT_ALLOW,
            //shadowingSendTwice: this.props.userEdit ? this.props.userEdit.shadowingSendTwice : "",
            typeIndex: this.props.userEdit ? this.getTextToIndex(USERTYPE_TEXT, this.props.userEdit.type) : "0",
            deleteFlg: this.props.userEdit ? this.props.userEdit.deleteFlg : false,
            nickname: this.props.userEdit ? this.props.userEdit.nickname : "",
            updateCourse: this.props.userEdit && this.props.userEdit.updateCourse ? String(this.props.userEdit.updateCourse) : COURSE_N.DEFAULT,
            updateCourseDate: this.props.userEdit && this.props.userEdit.updateCourseDate ? this.props.userEdit.updateCourseDate : "",

            displayCalendar: false,
            displayResetDlg: false,
            displayDeleteDlg: false,
            displayCreateDlg: false,
            displayInitDlg: false,
            displaySuccessInitDlg: false,
            calendarX: "0px",
            calendarY: "0px",
            calendarTarget: "",
            calendarIcon: {
                "subscribeDate": false,
                "paymentDate": false,
                "unsubscribeDate": false,
                "recessStartDate": false,
                "recessEndDate": false,
                "activateDate": false,
                "lastLoginDate": false,
                "updateCourseDate": false,
            }
        }
    }

    getCourseTextToIndex(course) {
        let array = [];
        for(let key in this.props.course) {
            array[String(key)] = this.props.course[key].name;
        }

        for (let key in array) {
            if (array[key] === course) {
                return key;
            }
        }
        return "-1";
    }
    getTextToIndex(array, course) {
        for (let key in array) {
            if (array[key] === course) {
                return key;
            }
        }
        return "-1";
    }

    getDisplayDate() {
        const today = new Date();
        let arr = today.toString().split(' ');
        let month = ('00' + (today.getMonth() + 1)).slice(-2);

        return arr[3] + '-' + month + '-' + arr[2];
    }

    componentDidMount() {
        this.props.dispatch({
            type: "CheckMaintenance_Saga"
        });
        this.props.dispatch({
            type: "LoadEnd"
        });
    }

    onCilckUpdate = (e) => {
        let err = [];
        let syserr = [];
        let currentDate = this.getDisplayDate();
        if (this.props.permission === 0) {
            syserr.push(ERROR_MESSAGE["permission_denied"]);
        }
        if (!validationEmail(this.state.address)) {
            err.push(ERROR_MESSAGE["invalid_mail"]);
        }
        if (this.state.typeIndex === USERTYPE.GENERAL.toString() &&
            this.state.course === "-1") {
            err.push(ERROR_MESSAGE["unselected_course"]);
        }
        // if (this.state.sendCount === "" || !validationNumeric(this.state.sendCount)) {
        //     err.push("送信回数には" + ERROR_MESSAGE["invalid_numeric"]);
        // }
        if (this.state.subscribeDate && this.state.subscribeDate !== "-" && !validationDate(this.state.subscribeDate)) {
            err.push("入会日が" + ERROR_MESSAGE["invalid_date"]);
        }
        if (this.state.paymentDate && this.state.paymentDate !== "-" && !validationDate(this.state.paymentDate)) {
            err.push("入金日が" + ERROR_MESSAGE["invalid_date"]);
        }
        if (this.state.unsubscribeDate && this.state.unsubscribeDate !== "-" && !validationDate(this.state.unsubscribeDate)) {
            err.push("退会日が" + ERROR_MESSAGE["invalid_date"]);
        }
        if (this.state.recessStartDate && this.state.recessStartDate !== "-" && !validationDate(this.state.recessStartDate)) {
            err.push("休会開始日が" + ERROR_MESSAGE["invalid_date"]);
        }
        if (this.state.recessEndDate && this.state.recessEndDate !== "-" && !validationDate(this.state.recessEndDate)) {
            err.push("休会終了日が" + ERROR_MESSAGE["invalid_date"]);
        }
        if (this.state.activateDate && this.state.activateDate !== "-" && !validationDate(this.state.activateDate)) {
            err.push("利用開始日が" + ERROR_MESSAGE["invalid_date"]);
        }
        if (this.state.updateCourseDate && this.state.updateCourseDate !== "-" && !validationDate(this.state.updateCourseDate)) {
            err.push("変更予定日が" + ERROR_MESSAGE["invalid_date"]);
        }
        if (this.state.updateCourse && this.state.updateCourse !== COURSE_N.DEFAULT && this.state.course === this.state.updateCourse) {
            err.push("変更後のコースは、現在のコースとは異なるものを選択してください");
        }
        if (this.state.updateCourseDate && this.state.updateCourseDate !== "-" && this.state.updateCourseDate <= currentDate) {
            err.push("変更予定日は、明日以降の日付を入力してください");
        }
        // if (this.state.lastLoginDate !== "-" && !validationDate(this.state.lastLoginDate)) {
        //     err.push("最終利用日時が" + ERROR_MESSAGE["invalid_date"]);
        // }
        if (err.length === 0 && syserr.length === 0) {
            if(this.state.createUser) {
                this.setState({
                    displayCreateDlg: true,
                })
            } else {
                this.props.dispatch({
                    type: "LoadStart"
                });
                let user = {
                    id: this.state.id,
                    address: this.state.address,
                    password: this.state.password,
                    userType: this.state.typeIndex,
                    permission: this.state.permission,
                    course: this.state.course,
                    nickname: this.state.nickname,
                    subscribeDate: this.state.subscribeDate,
                    paymentDate: this.state.paymentDate,
                    unsubscribeDate: this.state.unsubscribeDate,
                    recessStartDate: this.state.recessStartDate,
                    recessEndDate: this.state.recessEndDate,
                    activateDate: this.state.activateDate,
                    shadowingSendTwice: this.state.shadowingSendTwice,
                    updateCourse: this.state.updateCourse,
                    updateCourseDate: this.state.updateCourseDate,
                    onSuccess: this.onSuccessSet,
                    onFailure: this.onFailure,
                };
                this.props.dispatch({
                    type: "SetUser_Saga",
                    ...user
                });
            }
        } else {
            let message = [];
            for (let key in err) {
                message.push(
                    <div key={key}>
                        {err[key]}
                    </div>
                )
            }
            let errMessage;
            if (message.length > 0) {
                errMessage = PopupMessage({
                    type: POPUP_TYPE.INPUT_ERROR,
                    message: message
                });
            }
            message = [];
            for (let key in syserr) {
                message.push(
                    <div key={key}>
                        {syserr[key]}
                    </div>
                )
            }
            let syserrMessage;
            if (message.length > 0) {
                syserrMessage = PopupMessage({
                    type: POPUP_TYPE.SYS_ERROR,
                    message: message
                });
            }
            this.refToast.current.set(0, [
                syserrMessage,
                errMessage
            ]);
        }
    }
    onClickCancel = (e) => {
        this.props.history.push('/admin/user');
    }
    onClickDelete = (e) => {
        let syserr = [];
        if (this.props.permission === 0) {
            syserr.push(ERROR_MESSAGE["permission_denied"]);
        }
        if (syserr.length === 0) {
            this.setState({
                displayDeleteDlg: true,
            })
        } else {
            let message = [];
            for (let key in syserr) {
                message.push(
                    <div key={key}>
                        {syserr[key]}
                    </div>
                )
            }
            this.refToast.current.set(0,
                PopupMessage({
                    type: POPUP_TYPE.SYS_ERROR,
                    message: message,
                })
            );
        }
    }

    onSuccessRestore = (users) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.setState({
            displayDeleteDlg: false,
        })
        this.props.history.push('/admin/user');
    }

    onClickRestore = (e) => {
        let syserr = [];
        if (this.props.permission === 0) {
            syserr.push(ERROR_MESSAGE["permission_denied"]);
        }
        if (syserr.length === 0) {
            this.props.dispatch({
                type: "RestoreUser_Saga",
                id: this.state.id,
                onSuccess: this.onSuccessRestore,
                onFailure: this.onFailure,
            });
        } else {
            let message = [];
            for (let key in syserr) {
                message.push(
                    <div key={key}>
                        {syserr[key]}
                    </div>
                )
            }
            this.refToast.current.set(0,
                PopupMessage({
                    type: POPUP_TYPE.SYS_ERROR,
                    message: message,
                })
            );
        }
    }

    onClickPasswordReset = (e) => {
        if (this.state.createUser) {
            return;
        }
        let syserr = [];
        if (this.props.permission === 0) {
            syserr.push(ERROR_MESSAGE["permission_denied"]);
        }
        if (syserr.length === 0) {
            this.setState({
                displayResetDlg: true,
            })
        } else {
            let message = [];
            for (let key in syserr) {
                message.push(
                    <div key={key}>
                        {syserr[key]}
                    </div>
                )
            }
            this.refToast.current.set(0,
                PopupMessage({
                    type: POPUP_TYPE.SYS_ERROR,
                    message: message,
                })
            );
        }
    }

    onClickInitPassword = (e) => {
        if (this.state.createUser) {
            return;
        }
        let syserr = [];
        if (this.props.permission === 0) {
            syserr.push(ERROR_MESSAGE["permission_denied"]);
        }
        if (syserr.length === 0) {
            this.setState({
                displayInitDlg: true,
            })
        } else {
            let message = [];
            for (let key in syserr) {
                message.push(
                    <div key={key}>
                        {syserr[key]}
                    </div>
                )
            }
            this.refToast.current.set(0,
                PopupMessage({
                    type: POPUP_TYPE.SYS_ERROR,
                    message: message,
                })
            );
        }
    }

    onChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    }

    onChageCourse = (e) => {
        this.setState({ course: e.target.value });
    }

    onChageUpdateCourse = (e) => {
        this.setState({ updateCourse: e.target.value });
    }

    onChageUserType = (e) => {
        this.setState({
            type: USERTYPE_TEXT[e.target.value],
            typeIndex: e.target.value,
        });
    }

    onChagePermission = (e) => {
        this.setState({ permission: e.target.value });
    }

    onClickCalendarIcon(e, target) {
        let rect = this.refCalendar.current.getCalendarRect();
        let y;
        let x = this.refTable.current.offsetLeft + this.refTable.current.clientWidth;
        if (rect.height + e.pageY > window.innerHeight) {
            y = window.innerHeight - rect.height - 32;
        } else {
            y = e.pageY;
        }
        let icon = this.state.calendarIcon;
        icon[target] = true;
        this.setState({
            displayCalendar: true,
            calendarY: y + "px",
            calendarX: x + "px",
            calendarTarget: target,
            calendarIcon: icon,
        });
    }
    onChangeDate = (date, target) => {
        let icon = this.state.calendarIcon;
        icon[target] = false;
        this.setState({
            displayCalendar: false,
            [target]: date,
            calendarIcon: icon,
        });
    }
    onCalendarClose = (target) => {
        let icon = this.state.calendarIcon;
        icon[target] = false;
        this.setState({
            displayCalendar: false,
            calendarIcon: icon,
        });
    }

    onSuccessReset = () => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.setState({
            displayResetDlg: false,
        })
    }

    onClickResetCnf = () => {
        this.props.dispatch({
            type: "LoadStart"
        });
        this.props.dispatch({
            type: 'PWResetRequest_Saga',
            address: this.state.address,
            onSuccess: this.onSuccessReset,
            onFailure: this.onFailure,
        });
    }

    onSuccessInit = () => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.setState({
            displayInitDlg: false,
            displaySuccessInitDlg: true,
        })
    }

    onClickInitCnf = () => {
        this.props.dispatch({
            type: "LoadStart"
        });
        this.props.dispatch({
            type: 'PWInit_Saga',
            id: this.state.id,
            onSuccess: this.onSuccessInit,
            onFailure: this.onFailure,
        });
    }

    onSuccessDelete = (users) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.setState({
            displayDeleteDlg: false,
        })
        this.props.history.push('/admin/user');
    }
    onClickDeleteCnf = () => {
        this.props.dispatch({
            type: "LoadStart"
        });
        this.props.dispatch({
            type: "DeleteUser_Saga",
            id: this.state.id,
            onSuccess: this.onSuccessDelete,
            onFailure: this.onFailure,
        });
    }

    onSuccessSet = (users) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.setState({
            displayCreateDlg: false,
        })
        this.props.history.push('/admin/user');
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.setState({
            displayCreateDlg: false,
            displayDeleteDlg: false,
            displayResetDlg: false,
            displayInitDlg: false,
        })
    }

    onClickCreateCnf = () => {
        let user = {
            id: "",
            address: this.state.address,
            password: getRandomText(8),
            userType: this.state.typeIndex,
            permission: this.state.permission,
            course: this.state.course,
            nickname: this.state.nickname,
            subscribeDate: this.state.subscribeDate,
            paymentDate: this.state.paymentDate,
            unsubscribeDate: this.state.unsubscribeDate,
            recessStartDate: this.state.recessStartDate,
            recessEndDate: this.state.recessEndDate,
            activateDate: this.state.activateDate,
            shadowingSendTwice: this.state.shadowingSendTwice,
            updateCourse: this.state.updateCourse,
            updateCourseDate: this.state.updateCourseDate,
            onSuccess: this.onSuccessSet,
            onFailure: this.onFailure,
        };
        this.props.dispatch({
            type: "LoadStart"
        });
        this.props.dispatch({
            type: "SetUser_Saga",
            ...user
        });
    }
    onClickDlgCancel = () => {
        this.setState({
            displayResetDlg: false,
            displayDeleteDlg: false,
            displayCreateDlg: false,
            displayInitDlg: false,
        })
    }

    onClickSuccessInitCnf = () => {
        this.setState({
            displaySuccessInitDlg: false,
        })
    }

    createResetDlgProps() {
        return {
            display: this.state.displayResetDlg,
            contents: (
                <div style={{padding: "20px 0"}}>
                    パスワードリセットを実施します。<br/>
                    よろしいですか？<br/>
                    <br/>
                    <span style={{fontSize: "10px"}}>
                    OKを押すと、ユーザーにメールが送信されます。
                    </span>
                </div>
            ),
            controls: {
                'OK': {
                    Color: '#000',
                    onClick: this.onClickResetCnf,
                },
                'キャンセル': {
                    Color: '#000',
                    onClick: this.onClickDlgCancel,
                },
            },
            type: 1,
        }
    }

    createDeleteDlgProps() {
        return {
            display: this.state.displayDeleteDlg,
            contents: (
                <div style={{padding: "20px 0"}}>
                    このユーザーを削除します。<br/>
                    よろしいですか？<br/>
                    <br/>
                    <span style={{fontSize: "10px"}}>
                    復元ボタンで元に戻すことができます。
                    </span>
                </div>
            ),
            controls: {
                'OK': {
                    Color: '#000',
                    onClick: this.onClickDeleteCnf,
                },
                'キャンセル': {
                    Color: '#000',
                    onClick: this.onClickDlgCancel,
                },
            },
            type: 1,
        }
    }

    createCreateDlgProps() {
        return {
            display: this.state.displayCreateDlg,
            contents: (
                <div style={{padding: "20px 0"}}>
                    この情報でユーザーを追加します。<br/>
                    よろしいですか？<br/>
                    <br/>
                    <span style={{fontSize: "10px"}}>
                    設定されたメールアドレスにメールが送信されます。
                    </span>
                </div>
            ),
            controls: {
                'OK': {
                    Color: '#000',
                    onClick: this.onClickCreateCnf,
                },
                'キャンセル': {
                    Color: '#000',
                    onClick: this.onClickDlgCancel,
                },
            },
            type: 1,
        }
    }

    createInitDlgProps() {
        return {
            display: this.state.displayInitDlg,
            contents: (
                <div style={{padding: "20px 0"}}>
                    パスワードを初期化します。<br/>
                    よろしいですか？<br/>
                    <br/>
                </div>
            ),
            controls: {
                'OK': {
                    Color: '#000',
                    onClick: this.onClickInitCnf,
                },
                'キャンセル': {
                    Color: '#000',
                    onClick: this.onClickDlgCancel,
                },
            },
            type: 1,
        }
    }

    createSuccessInitDlgProps() {
        return {
            display: this.state.displaySuccessInitDlg,
            contents: (
                <div style={{padding: "20px 0"}}>
                    PWが初期化されました<br/>
                </div>
            ),
            controls: {
                'OK': {
                    Color: '#000',
                    onClick: this.onClickSuccessInitCnf,
                },
            },
            type: 1,
        }
    }

    render() {
        const width = window.innerWidth + "px";
        const height = (window.innerHeight - 64 - 64) + "px";
        const propsHeader = {
            title: "ユーザー管理",
            history: this.props.history,
        };
        const propsCalendar = {
            display: this.state.displayCalendar,
            top: this.state.calendarY,
            left: this.state.calendarX,
            target: this.state.calendarTarget,
            onClickDate: this.onChangeDate,
            onClose: this.onCalendarClose,
        };
        const propsToast = {
            timeout: 2000,
            bottom: "50px",
            right: "100px",
        };
        const propsResetDlg = this.createResetDlgProps();
        const propsDeleteDlg = this.createDeleteDlgProps();
        const propsCreateDlg = this.createCreateDlgProps();
        const propsInitDlg = this.createInitDlgProps();
        const propsSuccessInitDlg = this.createSuccessInitDlgProps();
        let type;
        if (this.state.createUser) {
            type = (
                <Select
                    array={USERTYPE_TEXT}
                    onChange={this.onChageUserType}
                    value={this.state.typeIndex}
                    style={{
                        padding: "2px 5px",
                        color: "#888",
                        width: "90%",
                        border: "none",
                        outline: "none",
                    }} />
            );
        } else {
            type = (
                <Select
                    array={USERTYPE_TEXT}
                    onChange={this.onChageUserType}
                    value={this.state.typeIndex}
                    style={{
                        padding: "2px 5px",
                        color: "#888",
                        width: "90%",
                        border: "none",
                        outline: "none",
                    }} />
            );
        }
        let updateButton;
        let deleteButton;
        if (this.state.createUser) {
            updateButton = (
                <Button
                Color="#0077FF"
                Width="100px"
                onClick={this.onCilckUpdate}
                icon={(<i className="fas fa-user-plus" />)}
                text="追加" />
            );
        } else {
            updateButton = (
                <Button
                Color="#0077FF"
                Width="100px"
                onClick={this.onCilckUpdate}
                icon={(<i className="fas fa-pen" />)}
                text="更新" />
            );
            if (this.state.deleteFlg) {
                if(this.props.userType === USERTYPE.ADMIN) {
                deleteButton = (
                    <Button
                        Color="#CF2626"
                        Width="100px"
                        onClick={this.onClickRestore}
                        icon={(<i className="fas fa-heart" />)}
                        text="復元" />
                );
                }
            } else if(this.props.userType === USERTYPE.ADMIN) {
                deleteButton = (
                    <Button
                        Color="#888888"
                        Width="100px"
                        onClick={this.onClickDelete}
                        icon={(<i className="fas fa-trash" />)}
                        text="削除" />
                );
            }
        }
        // [コース]用セレクトボックス
        let courseInfo = [];
        for(let key in this.props.course) {
            courseInfo[String(key)] = this.props.course[key].name;
        }
        // [変更後のコース]用セレクトボックス（デフォルトが"-"の状態）
        let changeCourseInfo = [];
        changeCourseInfo[COURSE_N.DEFAULT] = "-";
        for(let key in this.props.course) {
            changeCourseInfo[String(key)] = this.props.course[key].name;
        }
        return (
            <Body>
                <HeaderAdmin {...propsHeader}></HeaderAdmin>
                <ContentsWrap Width={width} Height={height}>
                    <Contents>
                        <Table ref={this.refTable}>
                            <EditRow title="種類" data={type} />
                            <EditRow title="ユーザーID" data={this.state.id} Enable={false}/>
                            <EditRow title="ニックネーム"
                                data={(
                                    <input type="text" name="nickname" value={this.state.nickname}
                                        onChange={this.onChange} />
                                )}
                                Display={this.state.typeIndex === USERTYPE.TRAINER.toString()} />
                            <EditRow title="メールアドレス*"
                                data={(
                                    <input type="text" name="address" value={this.state.address}
                                        onChange={this.onChange} />
                                )} 
                                Required={true}/>
                            <EditRow title="権限"
                                data={(
                                    <Select
                                        array={PERMISSION_TEXT}
                                        onChange={this.onChagePermission}
                                        value={this.state.permission}
                                        style={{
                                            padding: "2px 5px",
                                            color: "#888",
                                            width: "90%",
                                            border: "none",
                                            outline: "none",
                                        }} />
                                )}
                                Display={this.state.typeIndex === USERTYPE.TRAINER.toString() || this.state.typeIndex === USERTYPE.ADMIN.toString()} />
                            <EditRow title="パスワード"
                                data={(
                                    <React.Fragment>
                                        <InnerButton onClick={this.onClickPasswordReset}>
                                            リセットする
                                        </InnerButton>
                                        <InnerButton onClick={this.onClickInitPassword}>
                                            初期化する
                                        </InnerButton>                                       
                                    </React.Fragment>
                                )}
                                Display={this.state.typeIndex === USERTYPE.GENERAL.toString()} />
                            <EditRow title="コース"
                                data={(
                                    <Select
                                        array={courseInfo}
                                        onChange={this.onChageCourse}
                                        value={this.state.course}
                                        style={{
                                            padding: "2px 5px",
                                            color: "#888",
                                            width: "90%",
                                            border: "none",
                                            outline: "none",
                                        }} />
                                )}
                                Display={this.state.typeIndex === USERTYPE.GENERAL.toString()} />
                            <EditRow title="送信回数" data={this.state.sendCount} />
                            <EditRow title="入会日"
                                data={[
                                    <input key="subA" type="text" name="subscribeDate" value={this.state.subscribeDate}
                                        onChange={this.onChange} />,
                                    <Icon key="subB" onClick={e => this.onClickCalendarIcon(e, "subscribeDate")}
                                        Active={this.state.calendarIcon["subscribeDate"]}>
                                        <i className="far fa-calendar-alt" />
                                    </Icon>
                                ]}
                                Display={this.state.typeIndex === USERTYPE.GENERAL.toString()} />
                            <EditRow title="入金日"
                                data={[
                                    <input key="payA" type="text" name="paymentDate" value={this.state.paymentDate}
                                        onChange={this.onChange} />,
                                    <Icon key="payB" onClick={e => this.onClickCalendarIcon(e, "paymentDate")}
                                        Active={this.state.calendarIcon["paymentDate"]}>
                                        <i className="far fa-calendar-alt" />
                                    </Icon>
                                ]}
                                Display={this.state.typeIndex === USERTYPE.GENERAL.toString()} />
                            <EditRow title="退会日"
                                data={[
                                    <input key="unsubA" type="text" name="unsubscribeDate" value={this.state.unsubscribeDate}
                                        onChange={this.onChange} />,
                                    <Icon key="unsubB" onClick={e => this.onClickCalendarIcon(e, "unsubscribeDate")}
                                        Active={this.state.calendarIcon["unsubscribeDate"]}>
                                        <i className="far fa-calendar-alt" />
                                    </Icon>
                                ]}
                                Display={this.state.typeIndex === USERTYPE.GENERAL.toString()} />
                            <EditRow title="休会開始日"
                                data={[
                                    <input key="ressA" type="text" name="recessStartDate" value={this.state.recessStartDate}
                                        onChange={this.onChange} />,
                                    <Icon key="ressB" onClick={e => this.onClickCalendarIcon(e, "recessStartDate")}
                                        Active={this.state.calendarIcon["recessStartDate"]}>
                                        <i className="far fa-calendar-alt" />
                                    </Icon>
                                ]}
                                Display={this.state.typeIndex === USERTYPE.GENERAL.toString()} />
                            <EditRow title="休会終了日"
                                data={[
                                    <input key="reseA" type="text" name="recessEndDate" value={this.state.recessEndDate}
                                        onChange={this.onChange} />,
                                    <Icon key="reseB" onClick={e => this.onClickCalendarIcon(e, "recessEndDate")}
                                        Active={this.state.calendarIcon["recessEndDate"]}>
                                        <i className="far fa-calendar-alt" />
                                    </Icon>
                                ]}
                                Display={this.state.typeIndex === USERTYPE.GENERAL.toString()} />
                            <EditRow title="利用開始日"
                                data={[
                                    <input key="actA" type="text" name="activateDate" value={this.state.activateDate}
                                        onChange={this.onChange} />,
                                    <Icon key="actB" onClick={e => this.onClickCalendarIcon(e, "activateDate")}
                                        Active={this.state.calendarIcon["activateDate"]}>
                                        <i className="far fa-calendar-alt" />
                                    </Icon>
                                ]}
                                Display={this.state.typeIndex === USERTYPE.GENERAL.toString()} />
                            <EditRow title="最終利用日時"
                                data={this.state.lastLoginDate}
                                Display={this.state.typeIndex === USERTYPE.GENERAL.toString()} />
                            <EditRow title="シャドーイング<br />2度送信"
                                data={(
                                    <React.Fragment>
                                        <input type="radio" name="shadowingSendTwice" id="shadowingSendTwice1" value={SHADOWING_SEND_TWICE.ALLOW}
                                            onChange={this.onChange} checked={this.state.shadowingSendTwice===SHADOWING_SEND_TWICE.ALLOW} />
                                        <label htmlFor="shadowingSendTwice1">許可</label>
                                        <input type="radio" name="shadowingSendTwice" id="shadowingSendTwice0" value={SHADOWING_SEND_TWICE.NOT_ALLOW}
                                            onChange={this.onChange} checked={this.state.shadowingSendTwice===SHADOWING_SEND_TWICE.NOT_ALLOW} />
                                        <label htmlFor="shadowingSendTwice0">許可しない</label>
                                    </React.Fragment>
                                )}
                                Display={this.state.typeIndex === USERTYPE.GENERAL.toString()} />
                            <EditRow title="変更後のコース"
                                data={(
                                    <Select
                                        array={changeCourseInfo}
                                        onChange={this.onChageUpdateCourse}
                                        value={this.state.updateCourse}
                                        style={{
                                            padding: "2px 5px",
                                            color: "#888",
                                            width: "90%",
                                            border: "none",
                                            outline: "none",
                                        }} />
                                )}
                                Display={this.state.typeIndex === USERTYPE.GENERAL.toString()} />
                            <EditRow title="変更予定日"
                                data={[
                                    <input key="updatePlanA" type="text" name="updateCourseDate" value={this.state.updateCourseDate}
                                        onChange={this.onChange} />,
                                    <Icon key="updatePlanB" onClick={e => this.onClickCalendarIcon(e, "updateCourseDate")}
                                        Active={this.state.calendarIcon["updateCourseDate"]}>
                                        <i className="far fa-calendar-alt" />
                                    </Icon>
                                ]}
                                Display={this.state.typeIndex === USERTYPE.GENERAL.toString()} />
                        </Table>
                        {this.props.userType === USERTYPE.TRAINER && <DisableInputArea />}
                    </Contents>
                </ContentsWrap>
                <Controls>
                    {updateButton}
                    <Button
                        Color="#888888"
                        Width="100px"
                        onClick={this.onClickCancel}
                        text="キャンセル" />
                    {deleteButton}
                </Controls>
                <Calendar ref={this.refCalendar} {...propsCalendar} />
                <Toast ref={this.refToast} {...propsToast} />
                <ModalDialog name="reset-dialog" {...propsResetDlg} />
                <ModalDialog name="delete-dialog" {...propsDeleteDlg} />
                <ModalDialog name="create-dialog" {...propsCreateDlg} />
                <ModalDialog name="init-dialog" {...propsInitDlg} />
                <ModalDialog name="SuccessInit-dialog" {...propsSuccessInitDlg} />
                <LoadingView Display={this.props.loading} />
            </Body>
        )
    }
}

const mapStateToProps = store => {
    return {
        loading: store.loading.loading,
        permission: store.login.user.permission,
        userEdit: store.userEdit.user,
        course: store.setting.course,
        userType: store.login.user.type,
    }
};

const connectedUserEdit = connect(mapStateToProps)(UserEdit);
export { connectedUserEdit as UserEdit };

const Body = styled.div`
    position: relative;
`;
const ContentsWrap = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;;
    flex-direction: column;
    margin: auto;
    padding-top: 20px;
    width: 50%;
    width: ${props => props.Width};
    height: ${props => props.Height};
    overflow: hidden scroll;
`;
const Contents = styled.div`
    position: relative;
`;

const Table = styled.div`
`;
const Row = styled.div`
    display: ${props => props.Display === undefined || props.Display ? 'flex' : 'none'};
    justify-content: flex-start;
    align-items: center;
    margin: 5px 0;
`;
const Title = styled.div`
    background-color: #888;
    color: #fff;
    padding: 10px 20px;
    text-align: center;
    min-width: 100px;
    margin: 0 5px;
`;
const Data = styled.div`
    padding: 10px 20px;
    min-width: 300px;
    border-bottom: 1px solid #ddd;
    margin: 0 5px;
    color: #888;
    height: 16px;
    display: flex;
    align-items: center;

    background-color: ${props => props.Enable === false ? "#f6f6f6" : props.Required ? "#fff0f0" : "transparent"};

    input {
        border: none;
        border-radius: 0;
        width: 90%;
        padding: 0;
        background-color: ${props => props.Required ? "#fff0f0" : "transparent"};
    }
    input[type="radio"] {
        border: none;
        border-radius: 0;
        width: 20px;
        padding: 0;
        margin: 5px 0;
        background-color: transparent;
    }
    select {
        padding: 0;
        margin: 0;
    }
    label {
        width: 30%;
    }
`;

const Controls = styled.div`
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50%;
`;

const InnerButton = styled.div`
    border: 1px solid #ddd;
    padding: 2px 10px;
    text-align: center;
    display: inline-block;
    cursor: pointer;
    margin: 0 5px;
`;

const Icon = styled.div`
    font-size: 16px;
    cursor: pointer;
    color: ${props => props.Active ? "#0077FF" : "#888888"};
`;

const DisableInputArea =  styled.div`
    position: absolute;
    height: 555px;
    width: 340px;
    background: rgb(128 128 128 / 10%);
    borderRadius: 8px;
    zIndex: 100;
    top: 0px;
    left: 150px;
    margin: 5px 5px
`;
